export default function Intro() {
    return (
      <main style={{ padding: "1rem 0" }}>
        <h2>Intro</h2>
      </main>
    );
  }